/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1682035200000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Fri Apr 21 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "split",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Split",
          "depth": 0,
          "id": "connect-to-split"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing users",
          "depth": 1,
          "id": "syncing-users"
        }, {
          "value": "Syncing segments",
          "depth": 1,
          "id": "syncing-segments"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      img: "img",
      h3: "h3",
      h4: "h4"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Users"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to Split users"
            }), _jsx(_components.td, {
              children: "Update, Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.split.io/reference/users-overview",
                children: "Users docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Segments"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to new or existing segments"
            }), _jsx(_components.td, {
              children: "Add, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.split.io/reference/segments-overview",
                children: "Segments docs"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", "\n", _jsx(_components.h2, {
        id: "connect-to-split",
        children: "Connect to Split"
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Split"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to ", _jsx(_components.strong, {
          children: "Split"
        }), " by entering your Split ", _jsx(_components.strong, {
          children: "API key"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["To retrieve an API key in Split, click your user icon located at the top left corner of the screen. From the drop-down menu, select ", _jsx(_components.strong, {
          children: "Admin setting"
        }), ". In the ", _jsx(_components.strong, {
          children: "Workspace settings"
        }), " section, select ", _jsx(_components.strong, {
          children: "API keys"
        }), ". You have the option to use an existing key or generate a new one by clicking on the ", _jsx(_components.strong, {
          children: "Actions"
        }), " button at the top right corner and selecting ", _jsx(_components.strong, {
          children: "Create Admin API key"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-split-api-key.png",
          alt: "Split API Keys"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["For more information, refer to ", _jsx(_components.a, {
          href: "https://help.split.io/hc/en-us/articles/360019916211-API-keys",
          children: "Split's API keys article"
        }), "."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Split destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Split destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-users",
        children: "Syncing users"
      }), "\n", _jsx(_components.p, {
        children: "When syncing users, you can choose to update or insert them. When inserting new users, they are created with a Pending status."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsx(_components.p, {
        children: "You can match rows from your model to users in Split on any column in your model and any user field in Split. Ensure the data types of the model column and Split field you select match."
      }), "\n", _jsxs(_components.p, {
        children: ["Refer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can map data from any of your model columns to fields in Split. If you are inserting users, you have the option to include email and groups. Additionally, you can update display name, email, disable 2FA, activate, and deactivate a user. Ensure the data types of your model columns match the data types of the fields you want to sync to."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-segments",
        children: "Syncing segments"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync data from any source to new or existing segments. You need to specify the ", _jsx(_components.a, {
          href: "https://docs.split.io/reference/workspaces-overview",
          children: "workspace"
        }), ", ", _jsx(_components.a, {
          href: "https://docs.split.io/reference/environments-overview",
          children: "environment"
        }), ", and ", _jsx(_components.a, {
          href: "https://docs.split.io/reference/traffic-types-overview",
          children: "traffic type"
        }), " to sync your segment. Segments are limited to 100,000 members and each update can only include 10,000 new members at a time."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to records in Split, you need to select the model column that contains the ", _jsx(_components.strong, {
          children: "identifier"
        }), " field."]
      }), "\n", _jsx(_components.h4, {
        id: "create-a-segment",
        children: "Create a segment"
      }), "\n", _jsxs(_components.p, {
        children: ["To create a new segment list, select ", _jsx(_components.strong, {
          children: "Create a new audience"
        }), ". You can provide a name for this segment, or Hightouch defaults to the name of the model used to create the sync."]
      }), "\n", _jsx(_components.p, {
        children: "When you create a segment, it will be added to the chosen environment. If you enter a name that already exists, segment creation fails."
      }), "\n", _jsx(_components.h4, {
        id: "use-an-existing-segment",
        children: "Use an existing segment"
      }), "\n", _jsxs(_components.p, {
        children: ["To use an existing segment list, select ", _jsx(_components.strong, {
          children: "Use existing segment"
        }), ". You can select any of your existing Split segments from the drop-down select menu."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
